import { makeStyles } from '@material-ui/core';

const styles = makeStyles((_theme) => ({
  drawerPaper: {
    // height: '15vh',
    alignItems: 'center',
    justifyContent: 'flex-end',
    display: 'flex',
    paddingLeft: 10,
  },

  avatar: {
    backgroundColor: '#444e53',
  },

  dateText: {
    margin: 10,
    color: '#444e53',
  },
  dateTextBold: {
    margin: 10,
    color: '#444e53',
    fontWeight: 'bold',
  },
  subHeaderStyle: {
    color: '#005abb',
    textDecorationLine: 'underline',
    textTransform: 'none',
    padding: 0,
  },
  '@keyframes productionPulse': {
    '0%, 100%': {
      opacity: 1,
      transform: 'scale(1)',
      boxShadow: '0 0 8px 2px rgba(211, 47, 47, 0.85)',
    },
    '50%': {
      opacity: 0.55,
      transform: 'scale(0.9)',
      boxShadow: '0 0 16px 5px rgba(211, 47, 47, 0.45)',
    },
  },
  environmentBanner: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  environmentLabel: {
    color: '#444e53',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  productionDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: '#d32f2f',
    flexShrink: 0,
    boxShadow: '0 0 8px 2px rgba(211, 47, 47, 0.85)',
    animation: '$productionPulse 2.4s ease-in-out infinite',
  },
  versionPills: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 4,
  },
  versionPill: {
    color: '#6b7579',
    backgroundColor: 'rgba(68, 78, 83, 0.08)',
    border: '1px solid rgba(68, 78, 83, 0.18)',
    borderRadius: 4,
    fontSize: '0.6rem',
    fontWeight: 500,
    letterSpacing: '0.02em',
    lineHeight: 1.2,
    padding: '2px 6px',
    whiteSpace: 'nowrap',
  },
  pollStatus: {
    marginLeft: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
  },
  liveIndicator: {},
  toggleRefresh: {
    fontSize: '9pt',
  },
  logoImage: {
    height: '5vh',
    margin: '10px 15px',
  },
}));

export default styles;
